"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BiToolsConnectorV2 = exports.BiConnectorsBaseDataModel = void 0;
exports.createBIConnectorResources = createBIConnectorResources;
exports.handleSpecificPropsForAWSAthena = exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _IntegrationSetup = _interopRequireDefault(require("@insided/deprecated-control/integrations/IntegrationSetup"));

var _BiConnectorOverviewDescriptionText = require("@insided/deprecated-control/integrations/components/bi-tools-connector/BiConnectorOverviewDescriptionText");

var _Tabs = require("@insided/deprecated-control/integrations/components/bi-tools-connector/Tabs");

var _PanelItems = require("@insided/deprecated-control/integrations/components/PanelItems");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _UninstallModal = _interopRequireDefault(require("@insided/deprecated-control/integrations/components/UninstallModal"));

var _notificationsS = _interopRequireDefault(require("@insided/control/modules/Core/notifications-s3"));

var _axios = _interopRequireDefault(require("axios"));

var _clipboard = _interopRequireDefault(require("@insided/deprecated-utils/clipboard"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _Checkbox = _interopRequireDefault(require("@insided/shared/uikit/Checkbox"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function createBIConnectorResources(icon, link) {
  return [{
    title: "How to connect?",
    icon: icon,
    link: link
  }, {
    title: "Getting Started with Data Analytics in CC Data Lake",
    icon: 'data-lake-connector-l',
    link: 'https://communities.gainsight.com/data-catalog-connectors-313/getting-started-with-data-analytics-in-cc-data-lake-26355'
  }, {
    title: "Data Catalog",
    icon: 'data-lake-connector-l',
    link: 'https://communities.gainsight.com/data-catalog-connectors-313'
  }];
}

var BiConnectorsBaseDataModel = {
  tableau: {
    appName: 'Tableau',
    headerTitle: 'Tableau Connector',
    appLogoName: 'tableau-l',
    appContainerBackgroundColor: '#1F457E',
    description: (0, _preact.h)(_BiConnectorOverviewDescriptionText.BiConnectorOverviewDescriptionTextV2, {
      type: "tableau"
    }),
    resources: createBIConnectorResources('tableau', 'https://communities.gainsight.com/bi-connector-to-cc-data-lake-silver-layer-beta-207/how-to-connect-tableau-with-customer-communities-data-lake-through-bi-connector-22842'),
    awsAthenaParams: [{
      label: 'Server',
      key: 'Server',
      defaultValue: ''
    }, {
      label: 'Port',
      key: 'Port',
      defaultValue: ''
    }, {
      label: 'S3 Staging Directory',
      key: 'OutputLocation',
      defaultValue: ''
    }, {
      label: 'Access Key/Username',
      key: 'accessKeyId',
      defaultValue: ''
    }]
  },
  looker: {
    appName: 'Looker',
    headerTitle: 'Looker Connector',
    appLogoName: 'looker-l',
    appContainerBackgroundColor: '#4285F4',
    description: (0, _preact.h)(_BiConnectorOverviewDescriptionText.BiConnectorOverviewDescriptionTextV2, {
      type: "looker"
    }),
    resources: createBIConnectorResources('looker', 'https://communities.gainsight.com/bi-connector-to-cc-data-lake-silver-layer-beta-207/how-to-connect-looker-with-customer-communities-data-lake-through-bi-connector-22844'),
    awsAthenaParams: [{
      label: 'Dialect',
      key: '',
      defaultValue: 'Amazon Athena'
    }, {
      label: 'Host',
      key: 'Host',
      defaultValue: ''
    }, {
      label: 'Port',
      key: 'Port',
      defaultValue: ''
    }, {
      label: 'Database',
      key: 'Database',
      defaultValue: ''
    }, {
      label: 'Access Key/Username',
      key: 'accessKeyId',
      defaultValue: ''
    }, {
      label: 'Additional JDBC Parameters',
      key: 'Workgroup',
      defaultValue: ''
    }]
  },
  s3: {
    appName: 'S3',
    headerTitle: 'Gainsight Data Share Connector',
    appLogoName: 'gainsight-l',
    appContainerBackgroundColor: '#05b4e6',
    description: (0, _preact.h)(_BiConnectorOverviewDescriptionText.BiConnectorOverviewDescriptionTextV2, {
      type: "s3"
    }),
    resources: createBIConnectorResources('gainsight-l', 'https://communities.gainsight.com/data-catalog-connectors-313/create-an-s3-connection-26350'),
    awsAthenaParams: [{
      label: 'Access Key/Username',
      key: 'accessKeyId',
      defaultValue: ''
    }, {
      label: 'Region',
      key: 'Region',
      defaultValue: ''
    }, {
      label: 'Bucket Name',
      key: 'BucketName',
      defaultValue: ''
    }, {
      label: 'S3 Path',
      key: 'S3Path',
      defaultValue: ''
    }]
  },
  powerbi: {
    appName: 'Power BI',
    headerTitle: 'Power BI Connector',
    appLogoName: 'power-bi-l',
    description: (0, _preact.h)(_BiConnectorOverviewDescriptionText.BiConnectorOverviewDescriptionTextV2, {
      type: "powerBi"
    }),
    appContainerBackgroundColor: '#FBBC04',
    resources: createBIConnectorResources('power-bi-l', 'https://communities.gainsight.com/bi-connector-to-cc-data-lake-silver-layer-beta-207/how-to-connect-power-bi-with-customer-communities-data-lake-through-bi-connector-22843'),
    awsAthenaParams: [{
      label: 'Region',
      key: 'Region',
      defaultValue: ''
    }, {
      label: 'Catalog',
      key: 'Catalog',
      defaultValue: ''
    }, {
      label: 'Database',
      key: 'Database',
      defaultValue: ''
    }, {
      label: 'Workgroup',
      key: 'Workgroup',
      defaultValue: ''
    }, {
      label: 'S3 Output Location',
      key: 'OutputLocation',
      defaultValue: ''
    }, {
      label: 'Encryption Options',
      key: 'EncryptionOptions',
      defaultValue: ''
    }, {
      label: 'Access Key/Username',
      key: 'accessKeyId',
      defaultValue: ''
    }]
  }
};
exports.BiConnectorsBaseDataModel = BiConnectorsBaseDataModel;
var messageMap = {
  id: 'Access key ID is copied to your clipboard.',
  secret: 'Secret access key is copied to your clipboard.'
};

var handleSpecificPropsForAWSAthena = function handleSpecificPropsForAWSAthena(connectorType) {
  var awsAthenaData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (connectorType === 'looker') {
    var separator = ":".concat(awsAthenaData.Port, ";");
    var splitProps = awsAthenaData.Host.split(separator);
    awsAthenaData.Host = splitProps[0];
    awsAthenaData['Additional JDBC Parameters'] = splitProps[1];
  }
};

exports.handleSpecificPropsForAWSAthena = handleSpecificPropsForAWSAthena;

var BiToolsConnectorV2 = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(BiToolsConnectorV2, _Component);

  var _super = _createSuper(BiToolsConnectorV2);

  function BiToolsConnectorV2() {
    var _this$props$isInstall, _this$props$accessKey;

    var _this;

    (0, _classCallCheck2.default)(this, BiToolsConnectorV2);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isInstalled: (_this$props$isInstall = _this.props.isInstalled) !== null && _this$props$isInstall !== void 0 ? _this$props$isInstall : false,
      credentials: {
        id: (_this$props$accessKey = _this.props.accessKeyId) !== null && _this$props$accessKey !== void 0 ? _this$props$accessKey : ''
      },
      activeTab: 0,
      showUninstallModal: false,
      notificationConfigurations: {
        targets: []
      },
      requestState: {
        type: 'success',
        title: '',
        message: ''
      },
      notificationTabKey: 'notification',
      targets: [],
      showAWSConnectionParams: false,
      uninstallCheckBoxParams: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "installButtonTimeout", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "uninstallButtonTimeout", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRemainingTimeout", function (baseTime) {
      var totalTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 120000;
      var baseTimestamp = new Date(baseTime).getTime();
      var now = Date.now();
      var elapsed = now - baseTimestamp;
      return totalTimeout - elapsed;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setButtonStatesWithTimeout", function (whichButton, remaining) {
      if (whichButton === 'uninstall') {
        _this.setState({
          isUninstallButtonDisabled: remaining > 0,
          isInstallButtonDisabled: false
        });

        if (remaining > 0) {
          _this.uninstallButtonTimeout = setTimeout(function () {
            _this.setState({
              isUninstallButtonDisabled: false
            });
          }, remaining);
        }
      } else if (whichButton === 'install') {
        _this.setState({
          isInstallButtonDisabled: remaining > 0,
          isUninstallButtonDisabled: false
        });

        if (remaining > 0) {
          _this.installButtonTimeout = setTimeout(function () {
            _this.setState({
              isInstallButtonDisabled: false
            });
          }, remaining);
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setupButtonTimeoutsOnMount", function () {
      _this.clearButtonTimeouts();

      var InstalledOn = _this.getInstalledOn();

      if (_this.props.isInstalled && InstalledOn) {
        var remaining = _this.getRemainingTimeout(InstalledOn);

        _this.setButtonStatesWithTimeout('uninstall', remaining > 0 ? remaining : 0);
      } else if (!_this.props.isInstalled && _this.props.ModifiedOn) {
        var _remaining = _this.getRemainingTimeout(_this.props.ModifiedOn);

        _this.setButtonStatesWithTimeout('install', _remaining > 0 ? _remaining : 0);
      } else {
        _this.setState({
          isInstallButtonDisabled: false,
          isUninstallButtonDisabled: false
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleInstallNow", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.onGenerateAccessKeys();

            case 2:
              _this.setActiveTab(1);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setShowAWSConnectionParams", function (value) {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          showAWSConnectionParams: value
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dismissMessage", function () {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          messageType: undefined,
          message: ''
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setActiveTab", function (selectedTab) {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          activeTab: selectedTab
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setRequestState", function (requestState) {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          requestState: requestState
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClickUninstallButton", function () {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          showUninstallModal: true
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeUninstallModal", function () {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          showUninstallModal: false
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUninstallConnector", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var successMessage, errorMessage, moderatorId;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              successMessage = "You've revoked the access keys successfully.";
              errorMessage = 'Sorry, something went wrong, please try again.';
              moderatorId = (0, _insidedDataStorage.getInsidedData)('user').userid; // Set loading state to disable button

              _this.setState({
                isUninstallLoading: true
              });

              _context2.prev = 4;
              _context2.next = 7;
              return _axios.default.post('/integration/bitoolsconnector/uninstall', {
                moderatorId: moderatorId
              });

            case 7:
              _this.setState(function (prevState) {
                return _objectSpread(_objectSpread({}, prevState), {}, {
                  isInstalled: false,
                  credentials: undefined,
                  showUninstallModal: false,
                  messageType: 'success',
                  message: successMessage,
                  isInstallButtonDisabled: true,
                  isUninstallLoading: false
                });
              }, function () {
                if (_this.installButtonTimeout) clearTimeout(_this.installButtonTimeout);
                _this.installButtonTimeout = setTimeout(function () {
                  _this.setState({
                    isInstallButtonDisabled: false
                  });
                }, 120000);
              });

              _context2.next = 14;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](4);

              _logger.logger.error(_context2.t0, {
                component: 'BiToolsConnectorV2',
                action: 'uninstall'
              });

              _this.setState({
                messageType: 'error',
                message: errorMessage,
                showUninstallModal: false,
                isUninstallLoading: false
              });

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 10]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCopy", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(field) {
        var credentials, _credentials$field;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                credentials = _this.state.credentials;

                if (!(field && credentials)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 4;
                return (0, _clipboard.default)((_credentials$field = credentials[field]) !== null && _credentials$field !== void 0 ? _credentials$field : '');

              case 4:
                _this.setState({
                  message: messageMap[field],
                  messageType: 'success'
                });

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onGenerateAccessKeys", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var successMessage, errorMessage, moderatorId, result, _result$data, accessKeyId, secretAccessKey;

      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this.setState({
                messageType: undefined,
                isLoading: true
              });

              successMessage = "Great news! By installing this app, you've automatically installed all four data lake connectors, which can be configured using the same Secret Access Key.";
              errorMessage = 'Sorry, something went wrong, please try again.';
              moderatorId = (0, _insidedDataStorage.getInsidedData)('user').userid;
              _context4.prev = 4;
              _context4.next = 7;
              return _axios.default.post('/integration/bitoolsconnector/install', {
                moderatorId: moderatorId
              });

            case 7:
              result = _context4.sent;
              _result$data = result.data, accessKeyId = _result$data.accessKeyId, secretAccessKey = _result$data.secretAccessKey;

              _this.setState(function (prevState) {
                return _objectSpread(_objectSpread({}, prevState), {}, {
                  isInstalled: true,
                  credentials: {
                    id: accessKeyId,
                    secret: secretAccessKey
                  },
                  messageType: 'infoV2',
                  message: successMessage,
                  isLoading: false,
                  isUninstallButtonDisabled: true
                });
              }, function () {
                if (_this.uninstallButtonTimeout) clearTimeout(_this.uninstallButtonTimeout);
                _this.uninstallButtonTimeout = setTimeout(function () {
                  _this.setState({
                    isUninstallButtonDisabled: false
                  });
                }, 120000);
              });

              _context4.next = 16;
              break;

            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](4);

              _logger.logger.error(_context4.t0, {
                component: 'BiToolsConnectorV2',
                action: 'install'
              });

              _this.setState(function (prevState) {
                return _objectSpread(_objectSpread({}, prevState), {}, {
                  isInstalled: false,
                  messageType: 'error',
                  message: errorMessage,
                  isLoading: false
                });
              });

            case 16:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[4, 12]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "uninstallCheckBoxUpdate", function () {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          uninstallCheckBoxParams: !prevState.uninstallCheckBoxParams
        });
      });
    });
    return _this;
  }

  (0, _createClass2.default)(BiToolsConnectorV2, [{
    key: "clearButtonTimeouts",
    value: function clearButtonTimeouts() {
      if (this.installButtonTimeout) clearTimeout(this.installButtonTimeout);
      if (this.uninstallButtonTimeout) clearTimeout(this.uninstallButtonTimeout);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setupButtonTimeoutsOnMount();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearButtonTimeouts();
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "getAWSAthenaDataByConnectorType",
    value: function getAWSAthenaDataByConnectorType(connectorType) {
      var params = BiConnectorsBaseDataModel[connectorType].awsAthenaParams;
      var awsAthenaData = {};

      var _iterator = _createForOfIteratorHelper(params),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _key2;

          var _step$value = _step.value,
              label = _step$value.label,
              key = _step$value.key,
              defaultValue = _step$value.defaultValue;
          awsAthenaData[label] = (_key2 = this.props[key]) !== null && _key2 !== void 0 ? _key2 : defaultValue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      handleSpecificPropsForAWSAthena(connectorType, awsAthenaData);
      return awsAthenaData;
    }
  }, {
    key: "getInstalledOn",
    value: function getInstalledOn() {
      // If not installed according to props but installed in state (local install)
      if (!this.props.isInstalled && this.state.isInstalled) {
        return new Date().toISOString();
      } // If installed according to props but not installed in state (local uninstall)


      if (!this.state.isInstalled && this.props.isInstalled) {
        return '';
      } // Default case: return the original prop value


      return this.props.InstalledOn;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          connectorType = _this$props.connectorType,
          ActivityStatus = _this$props.ActivityStatus,
          isNotificationEnabled = _this$props.isNotificationEnabled,
          s3NotificationWhitelistRole = _this$props.s3NotificationWhitelistRole;
      var _this$state = this.state,
          isInstalled = _this$state.isInstalled,
          credentials = _this$state.credentials,
          showUninstallModal = _this$state.showUninstallModal,
          isLoading = _this$state.isLoading,
          isUninstallLoading = _this$state.isUninstallLoading,
          message = _this$state.message,
          messageType = _this$state.messageType,
          activeTab = _this$state.activeTab,
          showAWSConnectionParams = _this$state.showAWSConnectionParams,
          uninstallCheckBoxParams = _this$state.uninstallCheckBoxParams,
          isInstallButtonDisabled = _this$state.isInstallButtonDisabled,
          isUninstallButtonDisabled = _this$state.isUninstallButtonDisabled;
      var awsAthenaData = this.getAWSAthenaDataByConnectorType(connectorType);
      var InstalledOn = this.getInstalledOn(); // Build tab titles and check if current activeTab is still valid
      // Check installation status from both props and state (state takes precedence for local changes)

      var isCurrentlyInstalled = this.state.isInstalled || isInstalled; // For S3 connector, assume notifications are enabled when installed

      var shouldShowNotificationTab = (isNotificationEnabled || isCurrentlyInstalled) && isCurrentlyInstalled && connectorType === 's3';
      var tabTitles = ['Resources', 'Installation'].concat((0, _toConsumableArray2.default)(shouldShowNotificationTab ? ['Notifications'] : [])); // If activeTab is out of bounds, reset to default tab (Resources)

      var validActiveTab = activeTab >= tabTitles.length ? 0 : activeTab;
      return (0, _preact.h)(_IntegrationSetup.default, (0, _extends2.default)({}, BiConnectorsBaseDataModel[connectorType], {
        tabTitles: tabTitles,
        tabContents: [(0, _preact.h)(_Tabs.ResourcesTabV2, {
          key: "resourcesTab",
          resources: BiConnectorsBaseDataModel[connectorType].resources
        }), (0, _preact.h)(_Tabs.InstallationTabV2, {
          key: "installationTab",
          appName: BiConnectorsBaseDataModel[connectorType].appName,
          credentials: credentials,
          isInstalled: isInstalled,
          isLoading: isLoading,
          showAWSConnectionParams: showAWSConnectionParams,
          awsAthenaData: awsAthenaData,
          setShowAWSConnectionParams: function setShowAWSConnectionParams(value) {
            return _this2.setShowAWSConnectionParams(value);
          },
          onClickCopy: this.handleCopy,
          onClickUninstall: this.onClickUninstallButton,
          onGenerateAccessKeys: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
            return _regenerator.default.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this2.onGenerateAccessKeys();

                  case 2:
                    return _context5.abrupt("return", _context5.sent);

                  case 3:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          })),
          isInstallButtonDisabled: isInstallButtonDisabled
        }), shouldShowNotificationTab && (0, _preact.h)(_notificationsS.default, {
          key: this.state.notificationTabKey,
          s3NotificationWhitelistRole: s3NotificationWhitelistRole
        })],
        onClickTab: function onClickTab(selectedTab) {
          return _this2.setActiveTab(selectedTab);
        },
        dismissMessage: this.dismissMessage,
        activeTab: validActiveTab,
        messageType: messageType,
        message: message,
        installedOn: InstalledOn,
        activityStatus: ActivityStatus,
        installButton: isInstalled ? (0, _preact.h)(_PanelItems.InstallAndUninstallButtons, {
          onClickUninstallButton: this.onClickUninstallButton,
          disabled: isUninstallButtonDisabled
        }) : (0, _preact.h)(_Button.default, {
          size: "medium",
          variant: "brand",
          title: "Install Now",
          className: "installation__button_cta",
          onClick: this.handleInstallNow,
          disabled: isInstallButtonDisabled
        }),
        uninstallModal: (0, _preact.h)(_UninstallModal.default, {
          headerTitle: BiConnectorsBaseDataModel[connectorType].headerTitle,
          showUninstallModal: showUninstallModal,
          enabledIntegrationCount: 0,
          isUninstallBtnDisabled: !uninstallCheckBoxParams || isUninstallLoading,
          customUninstallBtnText: "Uninstall all data lake connectors",
          customDescriptionTemplate: (0, _preact.h)(CustomBIConnectorsUninstallDescriptionTemplate, {
            uninstallCheckBoxParams: uninstallCheckBoxParams,
            onCheckBoxUpdate: this.uninstallCheckBoxUpdate
          }),
          onUninstall: this.onUninstallConnector,
          closeUninstallModal: this.closeUninstallModal
        })
      }));
    }
  }]);
  return BiToolsConnectorV2;
}(_preact.Component);

exports.BiToolsConnectorV2 = BiToolsConnectorV2;

var CustomBIConnectorsUninstallDescriptionTemplate = function CustomBIConnectorsUninstallDescriptionTemplate(_ref6) {
  var uninstallCheckBoxParams = _ref6.uninstallCheckBoxParams,
      onCheckBoxUpdate = _ref6.onCheckBoxUpdate;
  return (0, _preact.h)("div", null, (0, _preact.h)("p", null, "This action will also uninstall all other data lake connectors. All the credentials will be deleted and all integrations will be disabled"), (0, _preact.h)(_Checkbox.default, {
    onUpdate: onCheckBoxUpdate,
    checked: uninstallCheckBoxParams,
    label: "Uninstall all data lake connectors"
  }), (0, _preact.h)(_Checkbox.default, {
    onUpdate: onCheckBoxUpdate,
    checked: uninstallCheckBoxParams,
    label: "Delete all credentials and disable integrations using them"
  }));
};

var _default = BiToolsConnectorV2;
exports.default = _default;